<div class="row page-header">
    <div class="col-12">
        <h1>Shop Floor <small>(Beta) Priority work by station</small></h1>
    </div>
</div>

<div [hidden]="isInitialLoading">
    <div class="row action-toolbar mb-3">
        <div class="col-12">
            <form class="form-inline">
                <div class="form-group me-3 mb-2">
                    <label class="me-2" for="fabShopJobSelect">Job</label>
                    <wj-combo-box
                        id="fabShopJobSelect"
                        name="fabShopJobSelect"
                        [(ngModel)]="selectedJobId"
                        [itemsSource]="jobOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                        (selectedIndexChanged)="onJobChanged()"
                        style="width: 22rem"
                    ></wj-combo-box>
                </div>
            </form>
        </div>
    </div>

    <div class="dashboard-panels">
        @for (lane of lanes; track lane.category) {
            <section class="dashboard-panel">
                <h2 class="dashboard-panel-title">
                    {{ lane.displayName }}
                    <span class="badge bg-secondary ms-2">{{ lane.pieces.length }}</span>
                </h2>
                @if (lane.pieces.length === 0) {
                    <p class="text-muted mb-0">No pieces in this lane.</p>
                } @else {
                    <div class="table-responsive">
                        <table class="table table-sm table-hover align-middle mb-0">
                            <thead>
                                <tr>
                                    <th>DWG #</th>
                                    <th>Name</th>
                                    <th>Description</th>
                                    <th>Next</th>
                                    <th>Planned</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (piece of lane.pieces; track piece.id) {
                                    <tr [class]="riskClass(piece)">
                                        <td>
                                            {{ piece.markCode || '—' }}
                                            @if (piece.isOnHold) {
                                                <span class="badge bg-warning text-dark ms-1" [title]="piece.holdReasonName || 'On hold'"
                                                    >Hold</span
                                                >
                                            }
                                            @if (piece.priority != null) {
                                                <span class="badge bg-danger ms-1">P{{ piece.priority }}</span>
                                            }
                                        </td>
                                        <td>
                                            <div>{{ piece.name }}</div>
                                            <small class="text-muted">{{ piece.scope }}</small>
                                        </td>
                                        <td class="piece-description">{{ piece.description || '—' }}</td>
                                        <td>{{ piece.nextStepName || '—' }}</td>
                                        <td>{{ formatDate(piece.nextStepPlannedDate) }}</td>
                                        <td class="text-end">
                                            @if (canEdit && piece.nextStepId) {
                                                <button
                                                    type="button"
                                                    class="btn btn-sm btn-primary"
                                                    [disabled]="stampingPieceId === piece.id"
                                                    (click)="completeNextStep(piece)"
                                                >
                                                    Complete
                                                </button>
                                            }
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                }
            </section>
        }
    </div>
</div>
